import React from 'react';
import { COMPANY_NAME } from '../constants';

const Careers = () => {
  return (
    <div className="max-w-6xl mx-auto p-6 bg-white rounded shadow-md flex flex-col md:flex-row items-center md:items-start gap-6">
      <div className="md:w-1/2">
        <h2 className="text-3xl font-bold mb-4 text-gray-900">Careers at {COMPANY_NAME}</h2>
        <p className="mb-3 text-gray-700">Join our dynamic team and help us build innovative software solutions.</p>
        <p className="mb-3 text-gray-700">We are looking for talented individuals who are passionate about technology and collaboration.</p>
        <ul className="list-disc list-inside text-gray-700">
          <li>Software Engineers</li>
          <li>Product Managers</li>
          <li>UX/UI Designers</li>
          <li>Quality Assurance Specialists</li>
        </ul>
        <p className="mt-4 text-gray-700">Contact us to learn more about current openings and our company culture.</p>
      </div>
      <div className="md:w-1/2">
        <img
          src="https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&w=800&q=80"
          alt="Team Collaboration"
          className="rounded shadow-md w-full h-auto object-cover"
        />
      </div>
    </div>
  );
};

export default Careers;
